const DATE_FORMAT = 'YYYY-MM-DD'
const DATE_FORMAT_CN = 'YYYY年MM月DD日'
const DATE_TIME_FORMAT = 'YYYY-MM-DD, HH:mm'
const TIME_FORMAT = 'HH:mm'
const DATE_MONTH_FORMAT = 'YYYY-MM'

const COURSE_STATUS = { COMPLETED: 'COM', IN_PROGRESS: 'IP', NOT_STARTED: 'NS' }

const GANTT_CHART_COLOR = {
  INPROGRESS_B: '#2AD0A680',
  INPROGRESS_F: '#2AD0A6',
  COMPLETE_B: '#3366FF80',
  COMPLETE_F: '#3366FF',
  INACTIVE_B: '#BCB2B080',
  INACTIVE_F: '#BCB2B0',
  CANCEL_B: '#FF174480',
  CANCEL_F: '#FF1744',
}

const COLOR = {
  primary: '#ff0000',
  secondary: '#2D2D6C',
  secondary_20: '#3366FF',
  secondary_40: '#4D31DF',
  secondary_60: '#d7e0ed',
  secondary_80: '#CEE0FB',
  secondary_100: '#F8F8FF',
  secondary_120: '#3D85F0',
}

export {
  TIME_FORMAT,
  DATE_FORMAT,
  DATE_FORMAT_CN,
  DATE_TIME_FORMAT,
  DATE_MONTH_FORMAT,
  COURSE_STATUS,
  GANTT_CHART_COLOR,
  COLOR,
}
